import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const JenisKomoditi = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [jenisKomoditi, setJenisKomoditi] = useState('')

    useEffect(() => {
        const getJenisKomoditi = async () => {
            const response = await masterService.getJenisKomoditiById(id)
            setJenisKomoditi(response.data.jenisKomoditi)
        }
        getJenisKomoditi()
    }, [masterService, id])

    return (
        <>
            {jenisKomoditi}
        </>
    )
}

export default JenisKomoditi